import React from "react";
import { FaEye } from "react-icons/fa";

const ViewButton = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="w-6 h-6 flex justify-center items-center bg-green-100 text-green-500 rounded-full scale-100 hover:scale-110 duration-300"
    >
      <FaEye />
    </button>
  );
};

export default ViewButton;
